import { configureStore } from "@reduxjs/toolkit";
import UsersSlice from "../function-components/Redux/UsersSlice";

export default configureStore({
  reducer: {
    users: UsersSlice
  },
});
